import React, { useContext } from "react";

import Profile from "../pages/Profile";
import { Switch } from "react-router-dom";
import PrivateRoute from "../PrivateRoute";
import Container from "../Container";
import menu from "../AppNavigation/menu";
import AppNavigation from "../AppNavigation";
import filterRoutesByScopes from "../../utils/filterRoutesByScopes";
import CountryContext from "../../CountryContext";
import ServiceConfigurator from "../../components/ServiceConfigurator";
import WorksiteDetail from "../../pages/WorksiteDetail";
import WorksiteDocuments from "../../pages/WorksitesDocuments";
import WorksiteReference from "../../pages/WorksiteReference";
import WorksitesTasks from "../../pages/WorksitesTasks";
import TintometerSurvey from "../../pages/TintometerSurvey";
import Quotations from "@pages/Quotations";
import { ViewEditQuotationDraft } from "feature/quotations/quotation-draft/view-edit-quotation-draft";
import { NewQuotationFromRequest } from "feature/quotations/new-quotation-from-request";
function Dashboard() {
  const {
    country: { code },
  } = useContext(CountryContext);
  return (
    <AppNavigation>
      <Container>
        <Switch>
          {
            filterRoutesByScopes(menu, code)
              .reduce(
                // Flatten dropdown items into a single array
                (acc, route) => [
                  ...acc,
                  ...(route.dropdown ? route.dropdown : [route]),
                ],
                []
              )
              .map((route) => (
                // Generate private routes used by the dashboard router
                <PrivateRoute
                  key={route.href || route.externalHref}
                  exact={!route.notExact}
                  component={route.component}
                  path={`/${code}${route.href}`}
                  role={route.role}
                />
              ))
          }
          <PrivateRoute exact path={`/${code}/profile`} component={Profile} />
          <PrivateRoute
            path={`/${code}/service/:serviceId/survey/:surveyId`}
            component={TintometerSurvey}
          />
          <PrivateRoute
            path={`/${code}/service-configuration/:serviceId`}
            component={ServiceConfigurator}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id/reference/:reference_id`}
            component={WorksiteReference}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id/reference`}
            component={WorksiteReference}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id/tasks/list/:task_id/:activity_id/discussion/:note_id`}
            component={WorksitesTasks}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id/tasks/list/:task_id`}
            component={WorksitesTasks}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id/tasks/maps/:map_id`}
            component={WorksitesTasks}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id/tasks`}
            component={WorksitesTasks}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id/documents`}
            component={WorksiteDocuments}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id/note/:note_id`}
            component={WorksiteDetail}
          />
          <PrivateRoute
            path={`/${code}/worksites/:worksite_id`}
            component={WorksiteDetail}
          />
          <PrivateRoute
            path={`/${code}/quotations/:quotation_id/drafts/:draft_id/:duplicate`}
            component={ViewEditQuotationDraft}
          />          
          <PrivateRoute
            path={`/${code}/quotations/:quotation_id/drafts/:draft_id`}
            component={ViewEditQuotationDraft}
          />
          <PrivateRoute
            path={`/${code}/quotations/:quotation_id/drafts/new`}
            component={ViewEditQuotationDraft}
          />
          <PrivateRoute
              path={`/${code}/quotations/new/:payload`}
              component={NewQuotationFromRequest}
          />
          <PrivateRoute
            path={`/${code}/quotations/:quotation_id`}
            component={Quotations}
          />
        </Switch>
      </Container>
    </AppNavigation>
  );
}

export default Dashboard;
